// extracted by mini-css-extract-plugin
export var active = "_ai-a";
export var activeIndicator = "_ai-8";
export var animate = "_ai-9";
export var disabled = "_ai-b";
export var fullWidth = "_ai-2";
export var lg = "_ai-7";
export var md = "_ai-6";
export var redoButtonTabGroup = "_ai-0";
export var sm = "_ai-5";
export var tabButton = "_ai-3";
export var tabButtonsContainer = "_ai-1";
export var xs = "_ai-4";